// Third-party imports
import $ from 'jquery';
import 'parsleyjs';

// Module name
export const MODULE_NAME = 'validate_price';

export let global_vars = {};

// global arg is expected to be the window object when running in a browser
export function initialize(global) {
    price(global);
    priceMin(global);
}

// Formats a string currency value (without the currency symbol) and
// returns a "generic" value that can then be validated or parsed to a float
export function formatValue(value) {
    // We remove any spaces in the price
    value = value.replace(/\s/g, '');

    // If there's a comma within the last 3 indices of the string
    // we replace it as a decimal, otherwise it remains as a comma
    value = replaceCommaAsDecimal(value);

    // After ensuring that the decimal commas has been converted
    // we remove all other commas in the number
    value = value.replace(/,/g, '');
    return value;
}

// Validate price format
// valid: 20 OR 20.00 OR 1 000,00 in FR
// invalid: 20.5 OR 20,5 OR ,99 OR 20,0 OR 20.0
// global arg is expected to be the window object when running in a browser
function price(global) {
    let validationMessage = $('.validation-data').data('validation-message');

    global.Parsley.addValidator('price', {
        validateString: value => {
            value = formatValue(value);

            return !!value.match(/^\$?\d+([.,]00)?$/g);
        },
        messages: {
            en: validationMessage,
            fr: validationMessage,
        },
    });
}

// Validate price is equal to or greater than min value
function priceMin(global) {
    global.Parsley.addValidator('priceMin', {
        validateString: (value, min) => {
            min = parseFloat(min);
            value = formatValue(value);
            value = parseFloat(value);
            return value >= min;
        },
        messages: {
            en: 'This value must be equal to or larger than %s',
            fr: 'Le montant doit être égal ou supérieur à %s',
        },
    });
}

// If the cents have been separated using a comma, we replace
// the comma with a period
function replaceCommaAsDecimal(value) {
    let decimalIndexMin = value.length - 3;
    let commaIndex = value.lastIndexOf(',');
    // Only if the comma has one or two characters after it, as that indicates
    // that the user was using a comma to separate the dollars and cents
    if (commaIndex !== -1 && commaIndex >= decimalIndexMin) {
        let first = value.substring(0, commaIndex);
        let second = value.substring(commaIndex + 1);
        value = `${first}.${second}`;
    }
    return value;
}
